import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'receipt-header-partial',
  templateUrl: './receipt-header-partial.component.html',
  styleUrls: ['./receipt-header-partial.component.scss']
})
export class ReceiptHeaderPartialComponent {
  @Input() email: string;
  @Input() userName: string;
}
